export const modal = (element, type, data, container, event) => {
    const title = LanguageManager.getString('continue_session_modal_title');
    const description = LanguageManager.getString('continue_session_modal_description');
    const placeholder = LanguageManager.getString('continue_session_modal_placeholder');
    const continueLabel = LanguageManager.getString('continue');
    const closeLabel = LanguageManager.getString('close');

    const modal = {
        message: `
            <div style="padding: 10px 0;">
                <h2>${title}</h2>          
                <p>${description}</p>  
                <input type="email" placeholder="${placeholder}" class="form-control"/>
                <div class="errors"></div>
            </div> 
        `,
        closeButton: false,
        onEscape: true,
        backdrop: true,
        buttons: {
            confirm: {
                label: continueLabel,
                callback(event) {
                    Logger.info({event});
                    event.preventDefault();
                    const errorBag = event.delegateTarget.querySelector('.errors');
                    const input = event.delegateTarget.querySelector('input');
                    const footer = event.delegateTarget.querySelector(
                        '.modal-footer');
                    const email = input.value;
                    if (email === '') {
                        errorBag.innerText = LanguageManager.getString('validation_email_required');
                        return false;
                    }

                    footer.style.pointerEvents = 'none';
                    footer.style.opacity = '0.5';

                    container.componentList.FirebaseStorage
                        .loginWithEmail(email)
                        .then(() => container.componentList.FirebaseStorage.load())
                        .then(() => container.componentList.LRSConnector.loadStateByEmail(email))
                        .then((response) => {
                            bootbox.hideAll();
                            const {firstName, lastName, email} = container.componentList.FirebaseStorage.user;
                            container.componentList.LRSConnector.load(`${firstName} ${lastName}`, email);

                            let pageID = container.storage.getBookmark();
                            Logger.info('CONTINUE AS :: pageID', pageID);

                            // If the user doesn't have a bookmark yet, send them to the help page
                            pageID = pageID === -1 ? 'coursemap' : pageID;

                            // debugger;
                            // console.info("Navigation.Modal", data)
                            // Navigate to the user's bookmark of the card shuffle if there isn't a
                            container.router.navigate(`page/${pageID}`, {
                            // container.router.navigate(data.data, {
                                trigger: true,
                            });
                        })
                        .catch(error => {
                            footer.style.pointerEvents = 'initial';
                            footer.style.opacity = '1';
                            Logger.info('ERRORS from sign in', error.code, {error});
                            if (error.code === 'no_user_data') {
                                errorBag.innerText = LanguageManager.getString('thats_me_error_no_user_data');
                                return;
                            }
                            if (error.code === 'request_aborted') {
                                errorBag.innerText = LanguageManager.getString('thats_me_error_request_aborted');
                                return;
                            }
                            if (error.message && typeof error.message === 'string') {
                                errorBag.innerText = error.message;
                                return;
                            }
                            errorBag.innerText = LanguageManager.getString('auth_unknown_error');
                            // Keeping standard error so that users can pass on error details if needed
                            console.error('Unknown error occurred', {error});
                        });

                    return false;
                }
            },
            cancel: {
                label: closeLabel,
                callback(event) {
                    const input = event.delegateTarget.querySelector('input');
                    input.value = '';
                }
            },
        },
    };

    const dialog = bootbox.dialog(modal);

    dialog.init(() => {
        const input = dialog[0].querySelector('input');
        let confirm = dialog[0].querySelector('[data-bb-handler="confirm"]');

        if (!confirm) {
            confirm = dialog[0].closest('.bootbox')
                .querySelector('.modal-footer > .bootbox-accept');
        }

        input.addEventListener('keypress', event => {
            if (event.key === 'Enter') {
                confirm.click();
            }
        })
    })
};
